<template>
  <v-container grid-list-m>
    <v-row>
      <Indicadores1 :items="items" />
    </v-row>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="7">
        <Table
          :title="titleTable1"
          :headers="headersContRes"
          :arrayList="reservas"
          :opciones="false"
          :reserva="true"
        />
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="5">
        <Table
          :title="titleTable3"
          :headers="headersCoches"
          :coche="true"
          :arrayList="cochesD"
          :opciones="false"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="7">
        <Table
          :title="titleTable2"
          :headers="headersContRes"
          :arrayList="contratos"
          :opciones="false"
        />
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="5">
        <Table
          :title="titleTable4"
          :headers="headersClientes"
          :arrayList="clientes"
          :opciones="false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Indicadores1 from "../components/dashboard/Indicadores";
import Table from "@/components/base/Table.vue";
import Headers from "../headers";

export default {
  data() {
    return {
      contratos: [],
      titleTable1: "Reservas",
      titleTable2: "Contratos",
      titleTable3: "Coches libres",
      titleTable4: "Clientes",
      cochesD: [],
      cochesS: [],
      modoChart1: "column",
      modoChart2: "bar",
      headersContRes: Headers.headersContratoReservaHome,
      headersCoches: Headers.headersCochesHome,
      headersClientes: Headers.headersClientesHome,
      items: [
        {
          color: "indigo darken-1",
          cuantity: "",
          title: "Reservas",
          artist: "Reservas programadas",
        },
        {
          color: "indigo darken-1",
          cuantity: "0",
          title: "Contratos",
          artist: "Contratos abiertos",
        },
        {
          color: "indigo darken-1",
          cuantity: "",
          title: "Clientes",
          artist: "Total de clientes",
        },
        {
          color: "indigo darken-1",
          cuantity: "",
          title: "Coches",
          artist: "Total de coches",
        },
        {
          color: "indigo darken-1",
          cuantity: "",
          title: "Coches",
          artist: "Total de coches disponibles",
        },
        {
          color: "indigo darken-1",
          cuantity: "0",
          title: "Notas",
          artist: "Tareas a realizar",
        },
      ],
    };
  },
  created() {
    this.filtroCoches();
    this.totalClientes();
    this.totalCoches();
    this.totalTareas();
    this.totalReservas();
    this.cochesDisponibles();
  },
  components: {
    Indicadores1,
    Table,
  },
  // filters: {
  //   alquiler: (coches) => coches.filter((c) => c.dalquiler = true),
  //   venta: (coches) => coches.filter((c) => c.aventa = true),
  // },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuarios"]),
    ...mapState("clienteNamespace", ["cliente", "clientes"]),
    ...mapState("cocheNamespace", ["coche", "coches"]),
    ...mapState("tareaNamespace", ["tarea", "tareas"]),
    ...mapState("reservaNamespace", ["reserva", "reservas"]),
  },
  methods: {
    filtroCoches() {
      let me = this;
      this.coches.forEach((e) => {
        if (e.estado == 1) {
          me.cochesD.push(e);
        } else {
          this.cochesS.push(e);
        }
      });
    },
    totalReservas() {
      this.items[0].cuantity = this.reservas.length;
    },
    totalContratos() {
      this.items[1].cuantity = this.contratos.length;
    },
    totalClientes() {
      this.items[2].cuantity = this.clientes.length;
    },
    totalCoches() {
      this.items[3].cuantity = this.coches.length;
    },
    cochesDisponibles() {
      this.items[4].cuantity = this.cochesD.length;
    },
    totalTareas() {
      this.items[5].cuantity = this.tareas.length;
    },
  },
};
</script>
